var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _path, _rect72, _path2, _rect73, _rect74, _rect75, _rect76, _rect77;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParallel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 82,
    viewBox: "0 0 112 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.87305,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.873,
    y: 6,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 85.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95.873,
    y: 6,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87305,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 56.873,
    y: 16,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 75.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 85.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 95.873,
    y: 16,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87305,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 26.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 46.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 56.873,
    y: 26,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 75.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 85.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 95.873,
    y: 26,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87305,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 26.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 46.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 56.873,
    y: 36,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 75.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 85.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 95.873,
    y: 36,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87305,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 26.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 46.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 56.873,
    y: 46,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 75.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 85.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 95.873,
    y: 46,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87305,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 26.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 46.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 56.873,
    y: 56,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 75.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 85.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 95.873,
    y: 56,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87305,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 16.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 26.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 46.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 56.873,
    y: 66,
    width: 9,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 75.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 85.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 95.873,
    y: 66,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#E8E8E8",
    strokeWidth: 0.2
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2168,
    y: 29.4512,
    width: 23.0986,
    height: 98.1562,
    rx: 2,
    transform: "rotate(-90 7.2168 29.4512)",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9029 19.1783L56.3279 15.0973C56.2813 14.976 56.2323 14.836 56.1809 14.6773C56.1296 14.514 56.0806 14.3413 56.0339 14.1593C55.9359 14.5373 55.8356 14.8523 55.7329 15.1043L54.1579 19.1783H57.9029ZM60.7309 22.9023H59.6809C59.5596 22.9023 59.4616 22.872 59.3869 22.8113C59.3123 22.7507 59.2563 22.6737 59.2189 22.5803L58.2809 20.1583H53.7799L52.8419 22.5803C52.8139 22.6643 52.7603 22.739 52.6809 22.8043C52.6016 22.8697 52.5036 22.9023 52.3869 22.9023H51.3369L55.3479 12.8713H56.7199L60.7309 22.9023Z",
    fill: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2168,
    y: 75.4512,
    width: 23.0986,
    height: 98.1562,
    rx: 2,
    transform: "rotate(-90 7.2168 75.4512)",
    fill: "#EDE1E4",
    stroke: "#794E57",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0969 67.8243C56.4843 67.8243 56.8179 67.78 57.0979 67.6913C57.3779 67.6027 57.6066 67.479 57.7839 67.3203C57.9659 67.157 58.0989 66.9657 58.1829 66.7463C58.2669 66.5223 58.3089 66.2773 58.3089 66.0113C58.3089 65.4933 58.1246 65.085 57.7559 64.7863C57.3873 64.483 56.8343 64.3313 56.0969 64.3313H53.9269V67.8243H56.0969ZM53.9269 59.9423V63.3653H55.7189C56.1016 63.3653 56.4329 63.3233 56.7129 63.2393C56.9976 63.1553 57.2309 63.0387 57.4129 62.8893C57.5996 62.74 57.7373 62.5603 57.8259 62.3503C57.9146 62.1357 57.9589 61.9023 57.9589 61.6503C57.9589 61.0577 57.7816 60.626 57.4269 60.3553C57.0723 60.08 56.5216 59.9423 55.7749 59.9423H53.9269ZM55.7749 58.8713C56.3909 58.8713 56.9206 58.932 57.3639 59.0533C57.8119 59.1747 58.1783 59.3473 58.4629 59.5713C58.7523 59.7953 58.9646 60.0707 59.0999 60.3973C59.2353 60.7193 59.3029 61.0833 59.3029 61.4893C59.3029 61.7367 59.2633 61.9747 59.1839 62.2033C59.1093 62.4273 58.9949 62.6373 58.8409 62.8333C58.6869 63.0293 58.4909 63.2067 58.2529 63.3653C58.0196 63.5193 57.7443 63.6453 57.4269 63.7433C58.1643 63.8833 58.7173 64.147 59.0859 64.5343C59.4593 64.917 59.6459 65.421 59.6459 66.0463C59.6459 66.471 59.5666 66.8583 59.4079 67.2083C59.2539 67.5583 59.0253 67.8593 58.7219 68.1113C58.4233 68.3633 58.0546 68.5593 57.6159 68.6993C57.1773 68.8347 56.6779 68.9023 56.1179 68.9023H52.5759V58.8713H55.7749Z",
    fill: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 0.873047,
    width: 105.099,
    height: 5.77465,
    fill: "#D9D9D9"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 0.873047,
    y: 76.2266,
    width: 105.099,
    height: 5.77465,
    fill: "#D9D9D9"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 0.873047,
    width: 5.77465,
    height: 82,
    fill: "#D9D9D9"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 105.873,
    width: 6,
    height: 30,
    fill: "#D9D9D9"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 105.873,
    y: 52,
    width: 6,
    height: 30,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallel);
export default __webpack_public_path__ + "static/media/parallel.46c6b57d01f0f09b7c45d25db70ca87d.svg";
export { ForwardRef as ReactComponent };